import React, { useEffect ,useState} from 'react';
import SidebarWomen from '../sideBarWomen/sidebarWomen';
import data from '../womenData';
import Sorting from '../Sorting/sorting';
import './women.css'
import Content from '../contentComponents/content';
import Footer from '../homeComponents/footer';


export default function Women(){
    let arr = [...data];
    const [sortId, setSortId] = useState(0);
    const [item,setItem] = useState(arr);
    const [page,setPage] = useState(0);
    const [pagginationArray,setPaginationArray] = useState([])
    const [filter,setFilter] = useState({
        brand : "",
        Category : "",
        Discount : {
            first : 0,
            second : 100,
        },
    })
    useEffect(()=>{
        if(sortId == 0){
            arr = [...data];
            // console.log('0');
        }else if(sortId == 1){
          arr.sort((a,b)=>Number(a.price)-Number(b.price));
        //   console.log('1');
        }else if(sortId == 2){
          arr.sort((a,b)=>b.offer-a.offer);
        //   console.log('2');
        }else if(sortId == 3){
             arr.sort((a,b)=>Number(b.price)-Number(a.price));
            //  console.log('3');
            }else{
            
        }
        let filterArr = arr.filter((it)=>{
            // {console.log(it)}
         return (
         (filter.brand ? it.brand.toUpperCase() == filter.brand.toUpperCase() : true) &&
         (filter.Category ? it.product.toUpperCase().includes(filter.Category.toUpperCase()) : true) &&
         (filter.Discount.first<=Number(it.offer) && filter.Discount.second >=Number(it.offer))
         );
        });
        let res = filterArr;
        let len = Math.round(res.length/15);
        let pageArr = Array.from({length : len ? len : len+1 }).map((_,i)=> i+1);

        setPaginationArray(pageArr);
        let ans = res.slice(page*15,(page+1)*15)
        setItem(ans);


    },[filter.brand,filter.Category,sortId,filter.Discount,page])
        return (
            <>
        <div className='menRow'>
       <SidebarWomen filter={filter} setFilter={setFilter} />

       <div className='menCol'>
          <Sorting setSortId={setSortId} />
          <Content data={item} />
       </div>
       </div>

       <div className='Pagination'>
          {pagginationArray.map((it,idx)=>{
           return (
            <button className={page === idx ? 'paginationButton currentPage' : 'paginationButton'} onClick={()=> setPage(idx)}>{idx+1}</button>
           )
          })}  
       </div>

       <Footer />
       </>
        )
  
}